import { useApolloClient, useLazyQuery } from '@apollo/client'
import { IGraphqlQueryProps } from '@dtos/Pagination'
import { GET_MEMBERS_CONFIG } from '@services/api/graphql/queries/getMembersConfig'
import { CUSTOM_PRODUCT_LIST_PAGE_SIZE } from '@utils/customProductListPagination'
import { useCallback } from 'react'

interface IUseMembersConfigProps extends IGraphqlQueryProps {
  version: string
}

// O offset do loadMore da lista customizada sai de quantos itens estão na
// tela, então a primeira página tem que usar o MESMO tamanho de página.
const membersConfigVariables = (version: string) => ({
  version,
  customProductListLimit: CUSTOM_PRODUCT_LIST_PAGE_SIZE,
})

export const useGetMembersConfig = ({ version }: IUseMembersConfigProps) => {
  const client = useApolloClient()
  const [getMembersConfig, { data, loading, error, variables, called }] =
    useLazyQuery(GET_MEMBERS_CONFIG, {
      variables: membersConfigVariables(version),
    })

  // Vai à rede por fora da query observada: reexecutá-la com `network-only`
  // grava uma falha passageira no `error` dela e zera o `data`, e a home que
  // já estava na tela cairia para a padrão. Aqui a falha só rejeita a promise;
  // a resposta boa é escrita no cache e chega aos observadores como dado novo.
  const refreshMembersConfig = useCallback(
    () =>
      client.query({
        query: GET_MEMBERS_CONFIG,
        variables: membersConfigVariables(version),
        fetchPolicy: 'network-only',
      }),
    [client, version],
  )

  return {
    getMembersConfig,
    refreshMembersConfig,
    data,
    loading,
    error,
    variables,
    called,
  }
}
